import { render, staticRenderFns } from "./app-table-skeleton.vue?vue&type=template&id=9326de1a&scoped=true&"
import script from "./app-table-skeleton.vue?vue&type=script&lang=js&"
export * from "./app-table-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./app-table-skeleton.vue?vue&type=style&index=0&id=9326de1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9326de1a",
  null
  
)

export default component.exports